import { produce } from 'immer';

import { UpdateInternalProduct } from '../../../actions/products/internal/updateInternalProduct';
import { ProductsState } from '../../../typings/products';

export function updateInternalProduct(state: ProductsState, action: UpdateInternalProduct): ProductsState {
    return produce(state, draft => {
        for (const products of [draft.products, draft.filtered]) {
            const product = products.find(item => item.id === action.product.id);

            if (product) {
                product.id = action.product.id;
                product.productName = action.product.productName;
                product.productLogin = action.product.productLogin;
                product.description = action.product.description;
                product.productAccess = action.product.productAccess;
                product.isSaved = action.product.isSaved;
                product.ulogin = action.product.ulogin;

                if (action.isSaved !== undefined) {
                    product.isSaved = action.isSaved;
                }
            }
        }
    });
}
